export const gTagEventName = {
  VIEW_ITEM: 'view_item',
  VIEW_ITEM_LIST: 'view_item_list',
};

export const gtag = function () {
  window.dataLayer.push(arguments);
};
